/**
 * Homebase component scroll utilities
 * Mostly a fork of wf_scroll, and scroll_top_helper
 */

import smoothScroll from '../smoothScroll';

const DEBOUNCE_DURATION = 250;

// Simple debounce implementation
// taken from https://gist.github.com/peduarte/7ee475dd0fae1940f857582ecbb9dc5f
function debounce(func, wait = 100) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}

function getScrollTop() {
  // Retrieve value from scrollingElement if available
  if (
    typeof document.scrollingElement !== 'undefined' &&
    document.scrollingElement !== null
  ) {
    return document.scrollingElement.scrollTop;
  }
  // fallback to documentElement or body on older browsers
  if (
    typeof document.body !== 'undefined' &&
    document.body !== null &&
    document.documentElement !== null
  ) {
    // Both can be defined, but we want to take the one that's not returning 0
    return Math.max(
      document.documentElement.scrollTop,
      document.body.scrollTop
    );
  }
  if (document.documentElement === null) {
    return 0;
  }
  return document.documentElement.scrollTop;
}

export default function registerScrollListener(eventListener, win = window) {
  const debouncedHandler = debounce(
    () => eventListener({scrollTop: getScrollTop()}),
    DEBOUNCE_DURATION
  );
  // Subscribe to the scroll event
  win.addEventListener('scroll', debouncedHandler, {passive: true});

  // Return a cleanup function to unsubscribe from the event
  return () => {
    win.removeEventListener('scroll', debouncedHandler, {passive: true});
  };
}

// Helper method to scroll a target element with optionally some duration
export const animateScrollToTop = ({
  position,
  // @NOTE using both body and html for cross browser differences
  // firefox overflows at html-level and not body-level as webkit based browsers do
  // @see: https://stackoverflow.com/questions/21556752/jquery-scrolltop-not-working-on-body-element-in-firefox
  targetElement = 'body, html',
  duration = 0,
}) => {
  const elements = targetElement.split(', ');
  elements.forEach((element) => {
    smoothScroll({
      element: document.querySelector(element),
      duration,
      y: position,
    });
  });
};
